import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../../General/Button';
import {
  GoogleTagManager,
  redirectToExternalPage as redirect,
} from '../../../helpers';
import {
  LayoutWrapperStyled as LayoutWrapper,
  ContentStyled as Content,
  SkullSvgStyled as SkullSvg,
  TitleStyled as Title,
  MessageStyled as Message,
  UnderlineButtonStyled as UnderlineButton,
} from './styles/DarksideStyled';

const duration = 0.3;
const AnimationVariants = {
  initial: {
    opacity: 0,
    y: 15,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration,
      delay: duration,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -15,
    transition: {
      duration,
    },
  },
};

const DarksideLayout = () => {
  const STORE_URL =
    'https://store.wom.cl/planes/?utm_source=miwom&utm_medium=loggin&utm_id=darkside';

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/sso/darkside',
      pageName: 'SSO_DARKSIDE',
      encodeUser: false,
    });
  }, []);

  return (
    <LayoutWrapper>
      <AnimatePresence>
        <Content
          as={motion.div}
          variants={AnimationVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <SkullSvg />
          <Title>¡Darkside detected!</Title>
          <Message>
            Detectamos que el número ingresado, viene del lado oscuro.
            <br />
            Para ingresar a MIWOM primero debes pertenecer a WOM
          </Message>
          <Button
            color="bubbleGum"
            maxWidth="100%"
            margin="0 auto"
            click={() => redirect(STORE_URL)}
          >
            Pórtate aquí
          </Button>
          <UnderlineButton
            onClick={() => redirect(`${process.env.SSO_URL}login/movil`)}
          >
            Volver al inicio
          </UnderlineButton>
        </Content>
      </AnimatePresence>
    </LayoutWrapper>
  );
};

export default DarksideLayout;
